import React, { useEffect, useRef, useState } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'
// style
import style from './Marquee.module.scss'

/**
 * @param {object} props
*  content 滚动内容
 * speed 滚动速度
 * delay 延迟时间
 * direction: 滚动方向 row：水平  column ：垂直
 * @return {JSX}
 */
const Marquee = (props) => {
  const { content, speed, delay = 300, direction = 'row', isFadeIn = false, isLoop = true } = props
  const [ isNeddRoll, setNeedRoll ] = useState(false)
  const wrapRef = useRef(null)
  const contentRef = useRef(null)

  function start() {
    const wrapRefCur = wrapRef.current
    const contentRefCur = contentRef.current
    const wrapAspect = direction === 'row' ? wrapRefCur.offsetWidth : wrapRefCur.offsetHeight // 跑马灯内元素总长度
    const contentAspect = direction === 'row' ? contentRefCur.offsetWidth : contentRefCur.offsetHeight // 跑马灯占有的长度

    if (!wrapRefCur || !contentRefCur) return

    // // 渐隐出现
    isFadeIn && wrapRef.current.classList.add(style.show)

    if ( wrapAspect > contentAspect ) {
      setNeedRoll(false)
      wrapRefCur.style.removeProperty('animation-name')
      return
    }
    isLoop && setNeedRoll(true)

    // // 设置动画间隔
    wrapRefCur.style.animationDuration = `${Math.floor(contentAspect*1000 / speed)}ms`
    // 设置父级的宽度，防止样式污染
    if ( direction === 'row' ) {
      wrapRefCur.style.width = `${Math.floor(contentAspect*2)}px`
    } else {
      wrapRefCur.style.height = `${Math.floor(contentAspect*2)}px`
    }
    // 延迟之后开启动画
    wrapRefCur.classList.add(style.running)
  }
  useEffect(()=>{
    // content数据为空的话，直接return
    if ( content.props.children?.length == 0 ) return
    const delayer = setTimeout(() => {
      start()
    }, delay)
    return () => { clearTimeout(delayer) }
  }, [content.props.children?.length])

  return <div ref={wrapRef}
      styleName={classNames({
        'wrap': true,
        [`${direction}`]: true,
        'hide' : isFadeIn,
      })}>
    <div ref={contentRef}
        styleName="content">
      {content}
    </div>
      {/* 复制一份内容实现头尾相接的效果 */}
    {
      isNeddRoll &&  <div styleName={classNames({
        'content': true,
      })}>
        {content}
      </div>
    }
  </div>
}

export default CSSModules(Marquee, style, {allowMultiple: true})
